/**
 * Auth-Guard: schützt die App-Shell. Ohne Token → /login. Während des
 * Bootstrap (Token-Prüfung via /api/me) wird ein kurzer Ladezustand gezeigt.
 */
import { useEffect } from "preact/hooks";
import { useLocation } from "preact-iso";
import { isAuthenticated } from "../state/session";
import { authBootstrapping } from "../state/auth";

export function AuthGuard({ children }: { children: preact.ComponentChildren }) {
  const { route } = useLocation();
  const authed = isAuthenticated.value;
  const booting = authBootstrapping.value;

  useEffect(() => {
    if (!booting && !authed) route("/login", true);
  }, [booting, authed]);

  if (booting) {
    return (
      <div class="splash">
        <div class="splash__spinner" aria-hidden="true" />
        <p class="text-muted">Lädt …</p>
      </div>
    );
  }
  if (!authed) return null;
  return <>{children}</>;
}
